import { put, takeEvery } from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";
import {
  createTokenAPI,
  deleteTokenAPI,
  generateTokenAPI,
  getDomainsAPI,
  getListTokenAPI,
  updateTokenAPI,
} from "redux/api/tokenManagementAPI";
import { setShowLoadingScreen } from "redux/slices/global";
import {
  createToken,
  createTokenSuccess,
  deleteToken,
  deleteTokenSuccess,
  generateToken,
  generateTokenSuccess,
  getDomains,
  getDomainsSuccess,
  getListToken,
  getListTokenSuccess,
  updateToken,
  updateTokenSuccess,
} from "redux/slices/tokenManagement";

export default function* tokenManagement() {
  yield takeEvery(generateToken.type, GenerateToken);
  yield takeEvery(getDomains.type, GetDomains);
  yield takeEvery(createToken.type, CreatToken);
  yield takeEvery(getListToken.type, GetListToken);
  yield takeEvery(updateToken.type, UpdateToken);
  yield takeEvery(deleteToken.type, DeleteToken);
}

function* GenerateToken(action) {
  try {
    console.log("bbb");
    const response = yield generateTokenAPI();
    yield put(generateTokenSuccess(response.data.data));
    if (action.payload) {
      Notification("success", "Successfully!");
    }
  } catch (err) {
    Notification("error", err.response.data.error);
  }
}

function* GetDomains(action) {
  try {
    console.log("bbb");
    const response = yield getDomainsAPI();
    yield put(getDomainsSuccess(response.data.data));
  } catch (err) {
    Notification("error", err.response.data.error);
  }
}

function* CreatToken(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield createTokenAPI(action.payload);
    yield put(createTokenSuccess());

    const response = yield getListTokenAPI({
      limit: 100,
      page: 1,
      search_data: {},
    });
    yield put(getListTokenSuccess(response.data.data));

    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (err) {
    yield put(setShowLoadingScreen(false));
    Notification("error", err.response.data.error);
  }
}

function* GetListToken(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getListTokenAPI({
      limit: 100,
      page: 1,
      search_data: {},
    });
    yield put(getListTokenSuccess(response.data.data));
    yield put(setShowLoadingScreen(false));
  } catch (err) {
    Notification("error", err.response.data.error);
    yield put(setShowLoadingScreen(false));
  }
}

function* UpdateToken(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield updateTokenAPI(action.payload);
    yield put(updateTokenSuccess());

    const response = yield getListTokenAPI({
      limit: 100,
      page: 1,
      search_data: {},
    });
    yield put(getListTokenSuccess(response.data.data));

    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (err) {
    yield put(setShowLoadingScreen(false));
    Notification("error", err.response.data.error);
  }
}

function* DeleteToken(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield deleteTokenAPI(action.payload);
    yield put(deleteTokenSuccess());

    const response = yield getListTokenAPI({
      limit: 100,
      page: 1,
      search_data: {},
    });
    yield put(getListTokenSuccess(response.data.data));

    yield put(setShowLoadingScreen(false));
    Notification("success", "Successfully!");
  } catch (err) {
    yield put(setShowLoadingScreen(false));
    Notification("error", err.response.data.error);
  }
}
